/* eslint-disable arrow-body-style */
/* eslint-disable react/prop-types */
import React from 'react';
import Lottie from "lottie-react";
import speedometerAnonymity from './Speedometer_Anonymity_NoLoop_04_Lottie.json';

const SpeedometerAnonymity = (props) => {

    return (
        <Lottie animationData={JSON.parse(JSON.stringify(speedometerAnonymity))} {...props}/>
    );
}

export default SpeedometerAnonymity;




// WEBPACK FOOTER //
// ./frontend/pages/LiveMarkets/animations/speedometers/speedometerAnonymity.jsx